<template>
  <v-container class="Notification">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <v-toolbar class="my-md-auto " elevation="0" rounded="lg">
      <v-toolbar-title  class="hidden-md-and-down">
          <h2 v-if="this.item">
            <v-icon large class="mr-2">{{ icon(this.item.type.type) }}</v-icon>
            {{ $t('administration.notification.notification')}}
          </h2>
      </v-toolbar-title>
      <v-spacer />
      <div>
        <v-btn
          class="ml-2"
          v-if="this.item.view"
          color="primary"
          @click="noview"
        >
          {{ $t('administration.notification.noview')}}
        </v-btn>
        <v-btn
          class="ml-2"
          v-if="!this.item.view"
          color="primary"
          @click="view"
        >
          {{ $t('administration.notification.view')}}
        </v-btn>
      </div>
    </v-toolbar>

    <div  v-if="this.item">
      <v-row>
        <v-col md="12">
          <v-divider></v-divider>
          <v-row>
            <v-col md="2" >
              <strong class="ml-4">{{ $t('global.date') }}:</strong>
            </v-col>
            <v-col md="10">
              <span class="mr-2">{{ formatDateTime(this.item.date, 'long') }}</span>
            </v-col>
          </v-row>

        </v-col>


      </v-row>

      <v-row>
        <v-col md="12">
          <v-divider></v-divider>
          <v-row>
            <v-col md="2" >
              <strong class="ml-4">{{ $t('global.content') }}:</strong>
            </v-col>
            <v-col md="10">
              <span class="mr-2">{{ $t(item.type.name, item.data) }}</span>
            </v-col>
          </v-row>

        </v-col>


      </v-row>


    </div>
    </v-sheet>
      <Loading :visible="isLoading" />
  </v-container>

</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';

const servicePrefix = 'notification';

export default {
  name: 'NotificationShow',
  servicePrefix,
  components: {
      Loading,
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('notificationuser', {
      actioned: 'actioned',
      action: 'action',
      error: 'error',
      isLoading: 'isLoading',
    }),
    ...mapGetters('notificationuser', ['find'])
  },
  methods: {
    ...mapActions('notificationuser', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load',
      notificationuserPushAction: 'action'
    }),
    view() {
      var action = 'notification/' + this.item.id +'/view';
      this.notificationuserPushAction({action: action,values: {}});
    },
    noview() {
      var action = 'notification/'+ this.item.id +'/noview';
      this.notificationuserPushAction({action: action,values: {}});
    },
    updatedview(actioned) {
      console.log("updatedview");
      this.retrieve(this.item['@id']);
      this.showMessage(actioned.message);
    },
    updatednoview(actioned) {
      console.log("updatednoview");
      this.retrieve(this.item['@id']);
      this.showMessage(actioned.message);
    },
    icon(type) {
      if (type == 'security') return 'mdi-security';
      if (type == 'machine') return 'mdi-printer-3d';
      if (type == 'toolhead') return 'mdi-tools';
      if (type == 'materialsupply') return 'mdi-format-color-fill';
      if (type == 'industrialcomputer') return 'mdi-server';
      if (type == 'controlunit') return 'mdi-car-cruise-control';
      if (type == 'accessory') return 'mdi-cctv';
      return 'mdi-bell';
    },
  },
  watch: {
    actioned(actioned) {
      if (!actioned) {
        return;
      }
      var actionview = 'notification/' + this.item.id + '/view';
      var actionnoview = 'notification/' + this.item.id + '/noview';
      if (this.action == actionview) {
        this.updatedview(actioned);
      }
      if (this.action == actionnoview) {
        this.updatednoview(actioned);
      }
    },

    error(message) {
      message && this.showError(message);
    }
  }
};
</script>
